module.exports = __webpack_public_path__ + "static/img/aloevera.0729cab6.svg";